import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'template'];

  add() {
    this.containerTarget.append(this.templateTarget.content.cloneNode(true));
  }

  remove(event) {
    event.target.closest('[data-nested-rows-row]')?.remove();
  }
}
